import { Box, Grid, Typography } from "@mui/material"

import { BackIcon } from "../../utils/iconRefs/recipeStepsIcons"
import LoaderButton from "../buttons/loaderButton"

type Props = {
    text: string,
    buttonText: string,
    onClickBack: () => void,
    onButtonClick: () => void,
    buttonLoading: boolean
}

const StepsHeader = ({ text, buttonText, onClickBack, onButtonClick, buttonLoading = false }: Props): JSX.Element => (
    <Box sx={{ width: '100%', boxSizing: 'border-box', boxShadow: '0px 1px 4px 0px #00000040', justifyContent: 'space-between', padding: '5px 0', position: 'sticky', backgroundColor: '#fff' }}>
        <Grid alignItems="center" container
            spacing={1}>
            <Grid container item justifyContent='center'
                onClick={onClickBack} xs={2}>
                <BackIcon />
            </Grid>
            <Grid item xs={6}>
                <Typography textOverflow="clip" variant="h6">{text}</Typography>
            </Grid>
            <Grid container item justifyContent='center'
                xs={4}>
                <LoaderButton disabled={buttonLoading} loading={buttonLoading} onClick={onButtonClick}
                    text={buttonText} />
            </Grid>
        </Grid>
    </Box >
)

export default StepsHeader